import classNames from 'classnames';
import React from 'react';

import { ColorOption, getColors } from 'styleguide-v2/src/utils/colors';

import images from '../../../static/images';
import { useStyles } from './IconStyles';

type Props = {
  className?: string;
  color?: ColorOption;
  size?: 'small' | 'medium';
};

export const MentalHealthIcon = ({
  className,
  color = 'info',
  size = 'medium',
}: Props) => {
  const colors = getColors(color, 'contained');
  const styles = useStyles(colors);
  return (
    <img
      src={images.mentalHealth}
      className={classNames(className, styles[`${size}Size`])}
      alt="Mental Health"
    />
  );
};
